export const SOFTLINE_FEATURE_REMOTE_CONFIG = 'remoteConfig'
export const SOFTLINE_SETTINGS_REMOTE_CONFIG = 'remoteConfig'
